import axios from "axios";
import arrLogFunc from "@/utils";
import store from "@/store";

const api = axios.create({
  baseURL: store.getters["APICONFIG/baseUrlGuestV2"],
  headers: {
    Authorization: `Bearer`,
    Accept: "application/json"
  },
  timeout: 180000
});

api.interceptors.request.use(config => {
  config.baseURL = store.getters["APICONFIG/baseUrlGuestV2"];
  const token = store.state.token;
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(...arrLogFunc);

const guestWalletCheck = async params => {
  const resp = await api.get("/wallet/check", {
    params
  });
  return resp.data;
};

const guestEmailSave = async params => {
  const resp = await api.post("/email/save", params);
  return resp.data;
};

const guestEmailSendCode = async params => {
  const resp = await api.post("/email/send", params);
  return resp.data;
};

const guestEmailVerify = async params => {
  const resp = await api.post("/email/verify", params);
  return resp.data;
};

const guestDexAuthorize = async params => {
  const resp = await api.post("/authorize", params);
  return resp.data;
};

export {
  api,
  guestWalletCheck,
  guestEmailSave,
  guestEmailSendCode,
  guestEmailVerify,
  guestDexAuthorize
};
